import type { IconData } from '@stacksjs/iconify-core'

export const browserCode1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 23s8 4 8 6s-8 6-8 6m14-1h10\"/><path stroke-linejoin=\"round\" d=\"M3.539 39.743c.208 2.555 2.163 4.51 4.718 4.718C11.485 44.723 16.636 45 24 45s12.515-.277 15.743-.539c2.555-.208 4.51-2.163 4.718-4.718C44.723 36.515 45 31.364 45 24s-.277-12.515-.539-15.743c-.208-2.555-2.163-4.51-4.718-4.718C36.515 3.277 31.364 3 24 3s-12.515.277-15.743.539c-2.555.208-4.51 2.163-4.718 4.718C3.277 11.485 3 16.636 3 24s.277 12.515.539 15.743Z\"/><path stroke-linecap=\"round\" d=\"M3.5 13.5h41\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 8.5h2m6 0h2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default browserCode1
